import { Trans, useLingui } from "@lingui/react/macro";

import { Separator } from "@/components/ui/separator";

import ourImpactImage from "@/assets/images/counting-impact.jpeg";
import ourImpactImage2x from "@/assets/images/counting-impact.jpeg";

function CountingValue({ value, description }: { value: string; description: string }) {
  return (
    <div>
      <div className="mb-2 text-2xl font-bold lg:text-4xl">{value}</div>
      <Separator className="mb-4 bg-gray-200 dark:bg-gray-700" />
      <p className="text-gray-600">{description}</p>
    </div>
  );
}

const OurImpactSection = () => {
  const { t } = useLingui();
  const stats = [
    {
      value: "8.9/10",
      description: t`5000+ Real reviews. Real experiences. Exceptional stays. on booking.com`,
    },
    { value: "350+", description: t`Residences in Cairo` },
    { value: "30 Years+", description: t`Experience in serviced residences` },
    { value: "2,000+", description: t`Guest stays per year` },
  ];

  return (
    <section className="xs:gap-4 flex flex-row flex-wrap px-4 text-(--color-text-color-text-grey) sm:gap-4 lg:gap-10">
      <div className="lg:flex-1">
        <h2 className="mb-2 text-2xl leading-10 font-normal lg:mb-12 lg:text-5xl">
          <Trans>
            Counting <span className="font-bold">Our Impact</span>
          </Trans>
        </h2>
        <img
          srcSet={`${ourImpactImage} 1x, ${ourImpactImage2x} 2x`}
          alt="Counting Our Impact"
          loading="lazy"
          className="hidden rounded-4xl lg:block"
          width={678}
          height={386}
        />
      </div>
      <div className="flex flex-col justify-between lg:flex-1">
        <p className="mb-4 text-base leading-6 font-normal">
          <Trans>
            Trusted by thousands and growing every year, our commitment to quality, comfort, and
            consistency speaks for itself. Whether it’s the number of happy guests, our expanding
            presence, or our years of hands-on experience.
          </Trans>
        </p>

        <div className="mb-4 grid max-w-4xl grid-cols-2 gap-4 gap-12">
          {stats.map((stat) => (
            <CountingValue key={stat.value} value={stat.value} description={stat.description} />
          ))}
        </div>

        <img
          srcSet={`${ourImpactImage} 1x, ${ourImpactImage2x} 2x`}
          alt="Counting Our Impact"
          loading="lazy"
          className="block rounded-4xl lg:hidden"
        />
      </div>
    </section>
  );
};

export default OurImpactSection;
